import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import config from '@/config/empresas';

Vue.use(Vuetify);

const fallbackLightTheme = {
  primary: '#795DD3',
  secondary: '#33355E',
  accent: '#8c9eff',
  error: '#ff5252',
};

const fallbackDarkTheme = {
  primary: '#795DD3',
  secondary: '#33355E',
  accent: '#8c9eff',
  error: '#ff5252',
};

const runtimeTheme = (config && typeof config.theme === 'object' && config.theme)
  ? config.theme
  : fallbackLightTheme;

export default new Vuetify({
  theme: {
    dark: false,
    options: { customProperties: true },
    themes: {
      light: {
        ...fallbackLightTheme,
        ...runtimeTheme,
      },
      dark: {
        ...fallbackDarkTheme,
      },
    },
  },
});